// Determine if a product's sale price is currently active.
// Sale is active when sale_price_gbp is non-empty AND today falls within
// any provided start/end dates (open-ended ranges allowed).
export function isSaleActive(product, today = new Date()) {
  if (!product) return false;
  // Explicit toggle: sale is only active when admin has flipped the switch ON.
  if (!product.is_on_sale) return false;
  const sale = (product.sale_price_gbp || "").trim();
  if (!sale) return false;
  const t = today.getTime();
  const parseDate = (s) => {
    if (!s) return null;
    const d = new Date(s);
    return Number.isNaN(d.getTime()) ? null : d.getTime();
  };
  const start = parseDate(product.sale_start);
  const end = parseDate(product.sale_end);
  if (start && t < start) return false;
  if (end) {
    // Treat end as inclusive end-of-day
    const endOfDay = end + 24 * 60 * 60 * 1000 - 1;
    if (t > endOfDay) return false;
  }
  return true;
}

// Returns the effective price string used everywhere (cart, display, WhatsApp).
export function effectivePriceGbp(product) {
  if (isSaleActive(product)) return product.sale_price_gbp;
  return product.price_gbp;
}

export function discountPercent(product) {
  if (!isSaleActive(product)) return 0;
  const num = (s) => {
    const m = String(s || "").match(/(-?\d[\d,]*(\.\d+)?)/);
    return m ? parseFloat(m[1].replace(/,/g, "")) : 0;
  };
  const regular = num(product.price_gbp);
  const sale = num(product.sale_price_gbp);
  if (!regular || !sale || sale >= regular) return 0;
  return Math.round(((regular - sale) / regular) * 100);
}
